import { render, staticRenderFns } from "./ReservationConfirmation.vue?vue&type=template&id=5b91bbd5&scoped=true&"
import script from "./ReservationConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReservationConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReservationConfirmation.vue?vue&type=style&index=0&id=5b91bbd5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91bbd5",
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCard, BCol, BTable, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCard, BCol, BTable, BRow, BContainer})
    

export default component.exports